
import Vue from 'vue';
export default Vue.extend({
  name: 'App',
  mounted() {
    document.getElementById('loader')!.style.display = 'none';
  },
});
